import type { IImageLoader } from "@Components/ImageLoader";
import ImageLoader from "@Components/ImageLoader";

import type { IDiscountCouponBase } from "./DiscountCouponBase";
import { DiscountCouponBase, DiscountCouponType } from "./DiscountCouponBase";

export interface IDiscountCouponImage extends IDiscountCouponBase {
    couponImage: IImageLoader;
}

export class DiscountCouponImage extends DiscountCouponBase<IDiscountCouponImage> {
    protected couponType = DiscountCouponType.Image;

    protected renderCoupon = () => <ImageLoader {...this.props.couponImage} />;
}
